import { I18n } from '@calendly/i18n';
import { IconTag } from '@calendly/ui/components/glyphs/IconTag';
import { BodyText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import classNames from 'classnames';
import { isEmpty } from 'lodash-es';
import { forwardRef } from 'react';
import { WidgetContainer } from './widget_container';
const paramContainerCss = "pog20oo";

/** Solo UTM widget only — contact detail rows already space siblings via their parent gap. */
const paramContainerSpacedCss = "p10cx5xf";

/* wrap text so long UTM values (e.g. UUIDs) clamp to 2 lines.
 * -webkit-box required for -webkit-line-clamp. Stylelint's autoprefixer step rewrites
 * it to box and breaks line-clamping; this file is in .stylelintrc ignoreFiles for that reason. */
const paramTextCss = "p1r7fgjn";
const ParamContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(paramContainerCss, props.className)} />;
});
export const ParamRow = ({
  label,
  value,
  iconWrapperClassName,
  spaced = false
}) => {
  const text = `${label}=${value}`;
  const icon = <UiIcon icon={IconTag} size="small" spacingTop={4} />;
  return <ParamContainer className={spaced ? paramContainerSpacedCss : undefined}>
      {iconWrapperClassName ? <span className={iconWrapperClassName}>{icon}</span> : icon}
      <BodyText>
        <span className={paramTextCss} title={text}>
          {text}
        </span>
      </BodyText>
    </ParamContainer>;
};
export const UtmParamsWidget = ({
  event
}) => {
  const params = event?.invitee?.trackingParams?.map(({
    label,
    value
  }) => ({
    label,
    value
  })) || [];
  if (isEmpty(params)) return null;
  return <WidgetContainer title={I18n.t('publisher.meetings.utm_params')} showBorder={false} sectionWithBottomBorder noPadding>
      {params.map(({
      label,
      value
    }) => <ParamRow key={label} label={label} value={value} spaced />)}
    </WidgetContainer>;
};

require("./utm_params_widget.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./utm_params_widget.js");